import Backbone from 'backbone'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import template from './serie-selector-form.hbs'
import SerieSelect from '../serie-select'

/**
 * Prompts the user to select a serie when using the "Scoring Bands" analytic
 * option
 */
const ConstantValueForm = Backbone.View.extend({
	tagName: 'form',

	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.append(template())

		this.serieSourceSelect = SerieSelect.appendAndRender(
			this.$('.serie'),
			new SerieSelect({
				model: this.options.chart,
				name: 'serieSource',
				axis: this.options.axis,
				filter:  s => s.get('source').domainType === 'scorecard-item'
			}))

		this.formView.start()
	},

	submit: function() {
		const value = this.serieSourceSelect.val()
		this.trigger('done', value)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.serieSourceSelect], 'remove')
	}
})

export default ConstantValueForm
ConstantValueForm.__filename__ = 'charts/edit/analytics/serie-selector-form.js'
